<template>
  <div id="olvido-contrasena" class="bg-azul-claro">
    <Volver redireccion="Inicio" />
    <Titulo subtitulo="Ingresa los datos solicitados a continuación">
      <b-col cols="12" md="6" class="mt-3">
        <label class="mb-1 font-weight-bold">RUN apoderado</label>
        <b-input
          data-testid="form-run"
          v-model="rut"
          type="text"
          class="form-control form-control-lg placeholder borde-amarillo"
          id="form_rut"
          placeholder="21.123.456-1"
          maxlength="12"
          :state="this.tieneError('rut')"
          @keyup.once="modificado.push('rut')"
          @change="validarRut"
          @keyup="formatoRut"
          autocomplete="off"
        />
        <b-form-invalid-feedback>
          {{ this.mensajeError("rut") }}
        </b-form-invalid-feedback>
      </b-col>
      <b-col cols="12" md="6" class="mt-3">
        <InputWrapperSerie
          negrita="true"
          grande="true"
          v-model="serie"
          :state="this.tieneError('serie')"
          :mensajeError="this.mensajeError('serie')"
          @keyup.once="modificado.push('serie')"
          @keyup="formatoSerie"
          @change="validarSerie"
        />
      </b-col>
      <div class="mt-3 mt-lg-4 mb-2 font-weight-bold mx-auto text-center">
        *Recuerda que si postulaste con IPA (200.123.456-7), solo podrás
        reestablecer tu contraseña llamando al 600 600 26 26 o directamente en
        las oficinas de atención ciudadana de Ayuda Mineduc.
      </div>
      <b-row
        class="bg-azul-claro py-3 py-lg-4 px-2 px-lg-5 text-center mx-2 w-100 justify-align-center text-center"
      >
        <b-col
          cols="12"
          lg="auto"
          class="ml-0 ml-lg-auto pl-2 pr-lg-5 mx-auto text-center"
          v-if="
            parseInt(modoRecuperarPassword) === 0 ||
              parseInt(modoRecuperarPassword) === 2
          "
        >
          <div class="form-check">
            <label class="d-flex align-items-center">
              <input
                data-testid="form-radio-correo"
                type="radio"
                name="radio"
                v-model="usuario.medioContacto"
                value="CORREO_ELECTRONICO"
              />
              <span class="label-text">Correo electrónico</span>
              <font-awesome-icon
                icon="envelope"
                class="fa-3x ml-auto ml-lg-3 text-azul-claro"
              />
            </label>
          </div>
        </b-col>
        <b-col
          cols="12"
          lg="auto"
          class="ml-0 ml-lg-auto pl-2 pl-lg-auto pr-auto pr-lg-5 mx-auto text-center"
          v-if="
            parseInt(modoRecuperarPassword) === 1 ||
              parseInt(modoRecuperarPassword) === 2
          "
        >
          <div class="form-check">
            <label class="d-flex align-items-center">
              <input
                data-testid="form-radio-telefono"
                type="radio"
                name="radio"
                v-model="usuario.medioContacto"
                value="TELEFONO_MOVIL"
              />
              <span class="label-text">Teléfono móvil</span>
              <font-awesome-icon
                icon="sms"
                class="fa-3x ml-auto ml-lg-3 text-azul-claro"
              />
            </label>
          </div>
        </b-col>
      </b-row>
      <b-col cols="12" class="mb-2 mt-3 mt-lg-5 px-0 px-lg-3 text-center mb-5">
        <InvisibleRecaptcha
          v-if="captchaHabilitado"
          data-test="button-recuperar"
          id="enviar-form-captcha"
          :sitekey="siteKey"
          :validate="validarFormulario"
          :callback="captcha"
          theme="light"
          class="btn btn-lg btn-azul-oscuro2 gilmer text-left pr-3 mt-2 px-4 font-weight-bold"
          :disabled="false"
          type="submit"
          >Recuperar Contraseña</InvisibleRecaptcha
        >
        <button
          v-if="!captchaHabilitado"
          data-test="button-recuperar"
          id="enviar-form"
          class="btn btn-lg btn-azul-oscuro2 gilmer text-left pr-3 mt-2 px-4 font-weight-bold"
          @click.prevent="pruebaAutomatizada"
        >
          Recuperar Contraseña
        </button>
      </b-col>
    </Titulo>
  </div>
</template>
<script>
import Volver from "@/components/generales/Volver";
import Titulo from "@/components/generales/TituloRecuperarContrasena";
import InputWrapperSerie from "@/components/generales/inputs/InputWrapperSerie";
import { manejoErrores } from "@/assets/js/manejoErrores";
import Validador from "@/assets/js/validador";
import InvisibleRecaptcha from "@/components/generales/recaptcha/InvisibleRecaptcha";
import FormateaRut from "@/assets/js/formatoRut";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEnvelope, faSms } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import ApiLogin from "@/services/ApiLogin";
library.add(faEnvelope);
library.add(faSms);
export default {
  mixins: [manejoErrores],
  components: {
    Volver,
    Titulo,
    InputWrapperSerie,
    InvisibleRecaptcha,
    FontAwesomeIcon
  },
  data() {
    return {
      usuario: {
        run: "",
        cow: "",
        medioContacto: "CORREO_ELECTRONICO"
      },
      config: {
        headers: {},
        params: {}
      },
      serie: "",
      rut: "",
      siteKey: RECAPTCHA_PUBLIC_KEY,
      captchaHabilitado: localStorage.getItem("recatpchaHabilitado") || "true",
      modoRecuperarPassword: ""
    };
  },
  created() {
    const obtenerValorLocalStorage = (key, valorPorDefecto = "----") => {
      const valor = localStorage.getItem(key);
      return valor ? valor : valorPorDefecto;
    };
    this.modoRecuperarPassword = obtenerValorLocalStorage(
      "modoRecuperarPassword"
    );
    if (parseInt(this.modoRecuperarPassword) === 1) {
      this.usuario.medioContacto = "TELEFONO_MOVIL";
    }
  },
  methods: {
    //ELIMINAR ANTES DE PRODUCCION
    pruebaAutomatizada() {
      let formValido = this.validarFormulario();
      if (formValido) {
        this.config.headers = {
          "g-recaptcha-response": "recaptchaToken"
        };
        this.config.params = {
          tipoCaptcha: "INVISIBLE"
        };
        this.enviarFormulario();
      }
    },
    //ELIMINAR ANTES DE PRODUCCION
    async captcha(recaptchaToken) {
      if (recaptchaToken) {
        this.config.headers = {
          "g-recaptcha-response": recaptchaToken
        };
        this.config.params = {
          tipoCaptcha: "INVISIBLE"
        };
        await this.enviarFormulario();
      }
    },
    formatoRut() {
      this.rut = FormateaRut.formateaRut(this.rut);
    },
    formatoSerie() {
      this.serie = FormateaRut.formatearSerie(this.serie);
    },
    validarRut() {
      let valido = true;
      let valor = this.rut;
      let campo = "rut";
      this.limpiarError(campo);
      this.errorRut = false;
      if (valor.length < 1) {
        this.guardarError(campo, "El RUN ingresado no es válido");
        valido = false;
      } else if (
        !Validador.validarExpresion("rut", valor) ||
        !FormateaRut.digitoVerificador(valor)
      ) {
        this.guardarError(campo, "El Run no es válido");
        valido = false;
      }
      if (valido) {
        this.usuario.run = parseInt(
          valor
            .slice(0, -1)
            .split(".")
            .join("")
            .replace("-", "")
        );
      } else {
        this.errorRut = true;
      }
      return valido;
    },
    validarSerie() {
      let valido = true;
      let valor = this.serie;
      let campo = "serie";
      this.limpiarError(campo);

      if (valor.length < 1) {
        this.guardarError(
          campo,
          "El número de serie/documento es un campo obligatorio"
        );
        valido = false;
      } else if (!Validador.validarExpresion("serie", valor)) {
        this.guardarError(campo, "El número de serie/documento no es válido");
        valido = false;
      } else {
        this.usuario.cow = valor.replace(/\./g, "");
      }
      return valido;
    },
    validarFormulario() {
      this.$emit("cargar");
      let valido = true;
      this.modificado = ["rut", "serie", "contacto"];
      let validado = [this.validarRut(), this.validarSerie()];
      if (validado.includes(false)) {
        valido = false;
        this.$emit("cargado");
      }
      return valido;
    },
    async enviarFormulario() {
      let solicitudCambioClave = await ApiLogin.solicitudCambioClave(
        this.usuario,
        this,
        this.config
      );
      if (solicitudCambioClave) {
        this.$router.push({
          name: "RecuperarContrasena",
          params: {
            id: solicitudCambioClave.id,
            medio: solicitudCambioClave.medio
          }
        });
        return true;
      } else {
        this.$emit("cargado");
        return false;
      }
    }
  }
};
</script>
<style scoped>
.mensaje-error {
  font-size: 80%;
  color: #dc3545;
}
</style>



// WEBPACK FOOTER //
// src/pages/OlvidoContrasena.vue